import { TAO_KOE } from './../libs';

let promise = null;
const getAffinities = () => {
	const DY = window.DY;
	if ( 'function' !== typeof DY?.API ) {
		return Promise.resolve( {} );
	}

	return promise = promise ?? new Promise( ( resolve, reject ) => {
		DY.API( 'callback', () => {
			if ( 'function' !== typeof DY.ServerUtil?.getUserAffinities ) {
				resolve( {} );
				return;
			}

			DY.ServerUtil.getUserAffinities( ( err, res ) => {
				if ( err ) {
					reject( err );
				} else {
					resolve( res );
				}
			} );
		} );
	} ).then( ( affinities = {} ) => {
		return Object.fromEntries(
			Object.entries( affinities ).map( ( [ type, values ] ) => {
				return [
					type,
					Object.fromEntries(
						Object.entries( values ).map( ( [ affinityName, affinityValue ] ) => {
							if ( affinityName.startsWith( "'" ) && affinityName.startsWith( "'" ) ) {
								return [ affinityName.substring( 1, affinityName.length - 1 ), affinityValue ];
							}

							return [ affinityName, affinityValue ];
						} ),
					),
				];
			} ),
		);
	} );
};

const getAffinitiesSafe = ( timeout = 1000 ) => {
	return Promise.race( [
		getAffinities(),
		new Promise( ( resolve, reject ) => setTimeout( () => reject( {} ), timeout ) ),
	] ).catch( () => ( {} ) );
};

const initDyAffinitySort = ( scopeEl = document ) => {
	const containerEls = scopeEl.querySelectorAll( '[data-dy-sort="affinity"]' );
	containerEls.forEach( async( containerEl ) => {
		const affinities = await getAffinitiesSafe();
		if ( 0 === Object.keys( affinities ).length ) {
			return;
		}

		const sortItemEls = Array.from( containerEl.querySelectorAll( '[data-dy-affinity-type]' ) ).filter( ( affinityEl ) => containerEl === affinityEl.closest( '[data-dy-sort]' ) );
		sortItemEls.forEach( ( sortItemEl ) => {
			const [ type, value ] = [ sortItemEl.dataset.dyAffinityType, sortItemEl.dataset.dyAffinityValue ];

			// KOC-14496: Special Handling of Categories for Category path.
			if ( 'categories' === type ) {
				const levels = [ 'Categorypath_lvl2', 'Categorypath_lvl3', 'Categorypath_lvl4', 'categories_no_tmp' ];
				for ( const level of levels ) {
					let score = 0;
					// Aggregate all values for each key.
					Object.keys( ( affinities && affinities[ level ] ) ?? {} ).forEach( ( key ) => {
						if ( key.split( '|' ).includes( value ) ) {
							score += affinities[ level ][ key ];
						}
					} );

					if ( score ) {
						sortItemEl.dataset.dyAffinityScore = score;
						return true;
					}
				}
				sortItemEl.dataset.dyAffinityScore = '0';
			} else if ( 'brand' === type && 'CHANEL' === value ) {
				sortItemEl.dataset.dyAffinityScore = '9999999';
			} else {
				sortItemEl.dataset.dyAffinityScore = ( affinities && affinities[ type ] && affinities[ type ][ value ] ) ?? '0';
			}
		} );

		// Sort by Affinity Score.
		const sortedItemEls = sortItemEls.toSorted( ( sortItemElA, sortItemElB ) => {
			return ( parseFloat( sortItemElB.dataset.dyAffinityScore ) * 100 ) - ( parseFloat( sortItemElA.dataset.dyAffinityScore ) * 100 );
		} );

		// Re-Attach the elements at the front.
		sortedItemEls.toReversed().forEach( ( sortItemEl ) => {
			sortItemEl.parentElement.insertAdjacentElement( 'afterbegin', sortItemEl );
		} );

		// Toggle trigger first navItem.
		const firstSortItemEl = sortedItemEls.find( () => true );
		if ( firstSortItemEl && firstSortItemEl.classList.contains( 'mdl_tabbedcontent__nav-item' ) && ! firstSortItemEl.classList.contains( 'is-active' ) ) {
			firstSortItemEl.dispatchEvent( new CustomEvent( 'select-tab.sl' ) );
		}
	} );
};

// Init.
TAO_KOE.ready( 'dy-affinity-sort.js', () => initDyAffinitySort() );
document.addEventListener( 'load_submenu.koe', ( ev ) => {
	const containerEl = ( ev.detail && ev.detail.subMenu ) || ev.target.KOE_MENU_ITEM.getSubmenuElement();
	initDyAffinitySort( containerEl );
} );

// Export.
export {
	getAffinities,
	getAffinitiesSafe,
	initDyAffinitySort,
};
